export function initStep3() {
    if ($('.id--17').length) {
        moveStep3Elements()
        loginLink()
        freePrice()
        step3TextChanges()
        placeSocialsButtons()
    }
}

function loginLink() {
    const loginLink = $('#order-page-login-button')
    loginLink
        .insertAfter('.co-contact-information > h4')
        .wrap('<div class="form-group"></div>')
        .attr('data-target', 'login')
        .addClass('toggle-window')
        .text('Přihlásit se do mého účtu')
}

function moveStep3Elements() {
    $('.form-group.company-shopping').insertAfter('.form-group:has(#another-shipping)')
}

function placeSocialsButtons() {
    $('.popup-widget .social-login-buttons').clone().addClass('cloned-social-login').insertAfter('#order-page-login-button');
}

function step3TextChanges() {
    $('#order-page-login-button').text('Login')
}

function freePrice() {
    const shippingAndBilling = $(".order-summary-item:not([data-micro='cartItem'])")

    shippingAndBilling.each(function () {
        const price = $(this).find('.cart-item-price')
        if (price.text().trim() === '0 Kč') {
            $(this).addClass('free-price')
            price.text('Zdarma')
        }
    })
}
